module.exports = __webpack_public_path__ + "static/media/POWERGRID_F1.564db6ff.txt";